import React from 'react';

const statusClassMap = {
    ACTIVE: 'bg-soft-success text-success',
    INACTIVE: 'bg-soft-secondary text-secondary',
    SUSPENDED: 'bg-soft-danger text-danger',
};

const statusLabelMap = {
    ACTIVE: 'Activo',
    INACTIVE: 'Inactivo',
    SUSPENDED: 'Suspendido',
};

export const SearchResultProject = ({ item, onSelect }) => {
    const status = String(item?.status || '').toUpperCase();

    return (
        <button
            type="button"
            className="search-result-row"
            onClick={() => onSelect?.(item)}
        >
            <div className="d-flex align-items-start justify-content-between gap-3 w-100">
                <div className="min-w-0">
                    <div className="d-flex flex-wrap align-items-center gap-2 mb-1">
                        <span className="badge bg-soft-dark text-dark">{item?.code || 'Proyecto'}</span>
                        <span className={`badge ${statusClassMap[status] || 'bg-soft-secondary text-secondary'}`}>
                            {statusLabelMap[status] || status || 'Sin estado'}
                        </span>
                    </div>
                    <div className="search-result-row__title">{item?.name || 'Sin nombre'}</div>
                    <div className="search-result-row__meta">{item?.customer?.name || 'Sin cliente'}</div>
                </div>
            </div>
        </button>
    );
};
